import TriggerNode from './TriggerNode';
import WaitNode from './WaitNode';
import EmailNode from './EmailNode';
import SmsNode from './SmsNode';
import LabelNode from './LabelNode';
import ConditionNode from './ConditionNode';
import ActionNode from './ActionNode';

export { TriggerNode, WaitNode, EmailNode, SmsNode, LabelNode, ConditionNode, ActionNode };

// Defined outside any component to prevent re-creation on every render
export const nodeTypes = {
  triggerNode: TriggerNode,
  waitNode: WaitNode,
  emailNode: EmailNode,
  smsNode: SmsNode,
  labelNode: LabelNode,
  conditionNode: ConditionNode,
  demoFallbackActionNode: ActionNode,
};
